import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Login(){
  const navigate = useNavigate();
  useEffect(() => { 
    const userId = localStorage.getItem("userId"); 
    if (userId) navigate(`/dashboard/${userId}`); 
  }, [navigate]);

  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");

  const handleLogin = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, { email, password });
      localStorage.setItem("userId", res.data.user_id);
      localStorage.setItem("name", res.data.name);
      navigate(`/dashboard/${res.data.user_id}`);
    } catch (err) {
      alert("Login failed");
    }
  };

  return (
    <div className="container">
      <div className="card" style={{maxWidth:520, margin:"36px auto"}}>
        <h2>Welcome back</h2>
        <p className="small">Sign in to manage your interviews</p>
        <div style={{marginTop:12}}>
          <input className="input" placeholder="Email" onChange={e=>setEmail(e.target.value)} />
          <input className="input" type="password" placeholder="Password" onChange={e=>setPassword(e.target.value)} style={{marginTop:10}} />
          <div style={{display:"flex",gap:8,marginTop:12}}>
            <button className="btn" onClick={handleLogin}>Sign in</button>
            <button className="btn secondary" onClick={()=>navigate("/signup")}>Create account</button>
          </div>
        </div>
      </div>
    </div>
  );
}
